import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, WhatsappNumbersResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof WhatsappNumbersResponseDataSchema>>

const queryKey = ["whatsappNumbers"]

export const settingsWhatsappNumbersQuery = ({
  onSuccess,
}: { onSuccess?: (data: Response["data"]) => void } = {}) => {
  return queryOptions({
    queryKey,
    refetchInterval: (query) =>
      query.state.data?.some((number) =>
        number.coexistenceSyncs.some(
          (sync) =>
            sync.status === "pending" ||
            sync.status === "requesting" ||
            sync.status === "requested",
        ),
      )
        ? 5000
        : false,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/whatsapp/settings/numbers`)

      onSuccess?.(response.data.data)
      return response.data.data
    },
  })
}
